export class DeleteDocumentReqVm {
    UserID: string;
    DatabaseID: number;
    organizationID: number;
    DocumentIDs:any = [];
    placeholderIDs:any = [];
    officeID:number=0;
    OfficeIDList: any;
}


export class GetDocumentDetails {
    documentName: string;
    documentType: string;
    documentPath:string;
    fileSize:string;
    description:string;
    createdOn:Date;
    documentID:number;
    placeholderID:number;
    uploadedByFirstName;
    uploadedByLastName;
    externalUploadedBy;
}

export class DocumentDataModel
{
   // "KeyID\":0,\"Key\":\"Phone\",\"FieldName\":null,\"FieldID\":10055,\"Value\":\"(913) 339-9318\"
   keyID:number;
   key:string;
   fieldName:string;
   fieldID:number;
   values:string;
}

export class ShowDocumentDetails {
    documentName: string;
    documentType: string;
    documentPath:string;
    fileSize:string;
    description:string;
    createdOn:Date;
    UploadedBy:Date;
    AcceptedBy:Date;
    documentStatus:any;
    createdByFirstName:string;
    createdByLastName:string;
    statusChangedByFirstName:string;
    statusChangedByLastName:string;
    uploadedByFirstName:string;
    uploadedByLastName:string;
    isRequired:boolean;
    uploadedOn:Date;
    uploadedByImage:string;
    statusChangedByImage:string;
    statusChangedOn:Date;
    documentID:number;
}





